export default __webpack_public_path__ + "static/media/change_password.a49e977c.svg";